export const reportData = Symbol('reportData');
export const reportType = Symbol('reportType');
export const reportConf = Symbol('reportConf');
export const dataProvider = Symbol('dataProvider');
export const dataProviderConfig = Symbol('dataProviderConfig');
